import React, { useState } from "react";
import "./Shop.css";
import { FaSearch, FaShoppingCart } from "react-icons/fa";

const products = [
    { id: 1, src: '/combotsee1.jpg', name: 'Combontsee Hoodie', price: 340, category: 'women', sizes: ['S', 'M', 'L'], unavailableSizes: ['L'], colors: ['Red', 'Blue'] },
    { id: 2, src: '/combotsee2.jpg', name: 'Combo Ntsee Moodle', price: 275, category: 'women', sizes: ['S', 'M', 'L'], unavailableSizes: [], colors: ['Black', 'White'] },
    { id: 3, src: '/goat2.jpg', name: 'Goat Tshirt', price: 330, category: 'women', sizes: ['M', 'L', 'XL'], unavailableSizes: ['XL'], colors: ['No Color'] },
    { id: 4, src: '/Goat.jpg', name: 'Goat Tshirt', price: 300, category: 'women', sizes: ['S', 'M', 'L'], unavailableSizes: [], colors: ['Green', 'Purple'] },
    { id: 5, src: '/watch.png', name: 'Watches for Men', price: 2100, category: 'women', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] },
    { id: 6, src: '/jog.webp', name: 'Jacket', price: 2400, category: 'women', sizes: ['S', 'M', 'L', 'XL'], unavailableSizes: ['XL'], colors: ['Black', 'Gray'] },
    { id: 7, src: '/Airfoce.jpeg', name: 'Airforce', price: 2700, category: 'women', sizes: ['7', '8', '9'], unavailableSizes: ['7'], colors: ['No Color'] },
    { id: 8, src: '/sama.jpg', name: 'Body Cream', price: 200, category: 'women', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] },
    { id: 9, src: '/kids.webp', name: 'Kids Clothes', price: 250, category: 'kids', sizes: ['S', 'M', 'L'], unavailableSizes: ['M'], colors: ['No Color'] },
    { id: 10, src: '/woman1.jpg', name: 'Kids Clothes', price: 250, category: 'kids', sizes: ['S', 'M', 'L'], unavailableSizes: [], colors: ['No Color'] },
    { id: 11, src: '/woman2.png', name: 'Kids Clothes', price: 250, category: 'kids', sizes: ['S', 'M', 'L'], unavailableSizes: [], colors: ['No Color'] },
    { id: 12, src: '/cook1.webp', name: 'Cooker 1', price: 1500, category: 'cooking', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] },
    { id: 13, src: '/cook2.webp', name: 'Cooker 2', price: 1700, category: 'cooking', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] },
    { id: 14, src: '/cook3.webp', name: 'Cooker 3', price: 1800, category: 'cooking', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] },
    { id: 15, src: '/cook4.webp', name: 'Cooker 4', price: 1900, category: 'cooking', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] },
    { id: 16, src: '/cook5.webp', name: 'Cooker 5', price: 2000, category: 'cooking', sizes: ['One Size'], unavailableSizes: [], colors: ['No Color'] }
];

const categories = ["All Categories", "Kids", "Women", "Cooking"];

const Shop = () => {
    const [selectedCategory, setSelectedCategory] = useState("All Categories");
    const [cart, setCart] = useState([]);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [isPaymentOpen, setIsPaymentOpen] = useState(false);
    const [selectedColor, setSelectedColor] = useState({});
    const [selectedSize, setSelectedSize] = useState({});
    const [paymentDetails, setPaymentDetails] = useState({ name: "", cardNumber: "" });
    const [searchTerm, setSearchTerm] = useState("");

    const handleAddToCart = (product) => {
        if (!selectedColor[product.id] || !selectedSize[product.id]) {
            alert("Please select both color and size before adding to cart.");
            return;
        }

        setCart([...cart, { ...product, color: selectedColor[product.id], size: selectedSize[product.id] }]);
    };

    const handleRemoveFromCart = (index) => {
        const updatedCart = [...cart];
        updatedCart.splice(index, 1);
        setCart(updatedCart);
    };

    const handleProceedToPayment = () => {
        if (cart.length === 0) {
            alert("Your cart is empty.");
            return;
        }

        setIsPaymentOpen(true);
    };

    const handlePaymentSubmit = () => {
        if (!paymentDetails.name || !paymentDetails.cardNumber || paymentDetails.cardNumber.length !== 16 || isNaN(paymentDetails.cardNumber)) {
            alert("Please fill in all payment details correctly.");
            return;
        }

        alert("Payment Successful! Thank you for shopping.");
        setCart([]);
        setIsPaymentOpen(false);
        setPaymentDetails({ name: "", cardNumber: "" });
    };

    const handleCancelPayment = () => {
        setPaymentDetails({ name: "", cardNumber: "" });
        setIsPaymentOpen(false);
    };

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
    };

    const filteredProducts = selectedCategory === "All Categories"
        ? products
        : products.filter((product) => product.category === selectedCategory.toLowerCase());

    const searchedProducts = searchTerm
        ? filteredProducts.filter(product => 
            product.name.toLowerCase().includes(searchTerm.toLowerCase()))
        : filteredProducts;

    return (
        <div className="shop-container">
            {/* Search Bar */}
            <div className="search-container">
                <FaSearch className="search-icon" />
                <input
                    type="text"
                    placeholder="Search products..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
            </div>

            {/* Category Buttons */}
            <div className="categories">
                {categories.map((category) => (
                    <button 
                        key={category} 
                        onClick={() => handleCategoryChange(category)}
                        className={selectedCategory === category ? "active" : ""}
                    >
                        {category}
                    </button>
                ))}
            </div>

            {/* Products List */}
            <div className="items-list">
                {searchedProducts.map((product) => (
                    <div key={product.id} className="item-card">
                        <img src={product.src} alt={product.name} />
                        <h3>{product.name}</h3>
                        <p>R{product.price}</p>

                        {/* Color Selection */}
                        <select onChange={(e) => setSelectedColor({ ...selectedColor, [product.id]: e.target.value })}>
                            <option value="">Select Color</option>
                            {product.colors.map((color) => (
                                <option key={color} value={color}>{color}</option>
                            ))}
                        </select>

                        {/* Size Selection */}
                        <select onChange={(e) => setSelectedSize({ ...selectedSize, [product.id]: e.target.value })}>
                            <option value="">Select Size</option>
                            {product.sizes.map((size) => (
                                <option key={size} value={size} disabled={product.unavailableSizes.includes(size)}>
                                    {size} {product.unavailableSizes.includes(size) ? "(Unavailable)" : ""}
                                </option>
                            ))}
                        </select>

                        <button onClick={() => handleAddToCart(product)}>Add to Cart</button>
                    </div>
                ))}
            </div>

            {/* Cart Icon */}
            <div className="cart-icon" onClick={() => setIsCartOpen(!isCartOpen)}>
                <FaShoppingCart />
                <span className="cart-count">{cart.length}</span>
            </div>

            {/* Cart Modal */}
            {isCartOpen && (
                <div className="cart-modal">
                    <button className="cart-close" onClick={() => setIsCartOpen(false)}>X</button>
                    <h2>Your Cart</h2>
                    <div className="cart-items">
                        {cart.map((item, index) => (
                            <div key={index} className="cart-item">
                                {item.name} - R{item.price} - {item.color} - {item.size}
                                <button onClick={() => handleRemoveFromCart(index)}>Remove</button>
                            </div>
                        ))}
                    </div>
                    <div className="cart-total">Total: R{cart.reduce((acc, item) => acc + item.price, 0)}</div>
                    <button className="proceed-payment" onClick={handleProceedToPayment}>Proceed to Pay</button>
                </div>
            )}

            {/* Payment Form on the Right */}
            {isPaymentOpen && (
                <div className="payment-modal-right">
                    <h2>Enter Payment Details</h2>
                    <input
                        type="text"
                        placeholder="Cardholder Name"
                        value={paymentDetails.name}
                        onChange={(e) => setPaymentDetails({ ...paymentDetails, name: e.target.value })}
                    />
                    <input
                        type="text"
                        placeholder="Card Number"
                        value={paymentDetails.cardNumber}
                        onChange={(e) => setPaymentDetails({ ...paymentDetails, cardNumber: e.target.value })}
                    />
                    <button className="confirm-payment" onClick={handlePaymentSubmit}>Confirm Payment</button>
                    <button className="cancel-payment" onClick={handleCancelPayment}>Cancel</button>
                </div>
            )}
        </div>
    );
};

export default Shop;